export default __webpack_public_path__ + "static/assets/964ebf18d6afc9069f92c37f506e7ba4.jpg";